import type { InvitationConfig } from './invitation';
export type IntroAnimationType =
  | 'none'
  | 'envelope'
  | 'curtain'
  | 'fade'
  | 'zoom'
  | 'flip'
  | 'sparkle'
  | 'petals';

export interface ThemeConfig {
  invitation?: InvitationConfig;
  backgroundImage: string;
  textColor: string;
  backgroundColor: string;
  opacity: number;
  fontFamily: string;
  buttonColor?: string;
  buttonTextColor?: string;
  introAnimation?: IntroAnimationType;
  introTitle?: string;
  introSubtitle?: string;
}

export const DEFAULT_THEME: ThemeConfig = {
  backgroundImage: '',
  textColor: '#ffffff',
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  opacity: 0.75,
  fontFamily: 'IntroRust',
  buttonColor: '#a855f7',
  buttonTextColor: '#ffffff',
  introAnimation: 'none',
  introTitle: '',
  introSubtitle: '',
};

export const INTRO_ANIMATION_OPTIONS: { value: IntroAnimationType; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'envelope', label: 'Double-Door Card' },
  { value: 'curtain', label: 'Curtain Reveal' },
  { value: 'fade', label: 'Elegant Fade' },
  { value: 'zoom', label: 'Zoom In' },
  { value: 'flip', label: 'Card Flip' },
  { value: 'sparkle', label: 'Sparkle Burst' },
  { value: 'petals', label: 'Falling Petals' },
];
